import { Component, Vue, Watch } from 'vue-property-decorator';
import TopDualLogo from '@/components/TopDualLogo/TopDualLogo'
import { request } from '@/tools/request.ts';
import { allCountries } from '@/views/LocationPreferences/countries';

@Component<LocationPreferences>({
  components: {
    TopDualLogo,
  },
})
export default class LocationPreferences extends Vue {
  protected currentPosition: any = null;
  protected allowedGeo: boolean = true;
  protected userLat: number = 0;
  protected userLng: number = 0;
  protected selectedGeo: any = null;
  protected userCity: string = 'city';
  protected userCountry: string = '';
  protected locationSelect: string = 'city';
  protected countries: string[] = allCountries;
  protected geoOptions: any = {
    enableHighAccuracy: false,
    timeout: 60000,
    maximumAge: 0
  };

  public mounted() {
    this.getGeoLocation();
  }

  protected getGeoLocation() {
    navigator.geolocation.getCurrentPosition(this.geoSuccess, this.geoError, this.geoOptions);
  }

  protected geoSuccess(pos: any) {
    this.currentPosition = pos.coords;
    this.getCityNameFromGeo();
  }
  
  protected geoError(err: any) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
  }

  protected getCityNameFromGeo() {
    if (!this.currentPosition.latitude && this.currentPosition.longitude) return;

    request('get', `https://maps.googleapis.com/maps/api/geocode/json?latlng=${this.currentPosition.latitude},${this.currentPosition.longitude}&sensor=true&key=${process.env.VUE_APP_GEO_API_KEY}`).then(
      (response: any) => {
        const tempCityString: string = response.data.plus_code.compound_code.split(' ')[1];
        this.userCity = tempCityString.slice(0, -1);
        this.locationSelect = this.userCity;
      },
      (error: any) => {
        console.log('request error', error);
      }
    );
  }

  protected getGeoFromCountry() {
    request('get', `https://maps.googleapis.com/maps/api/geocode/json?address=${this.userCountry}&key=${process.env.VUE_APP_GEO_API_KEY}`).then(
      (response: any) => {
        this.selectedGeo = response.data.results[0].geometry.location;
      },
      (error: any) => {
        console.log('request error', error);
      }
    );
  }

  protected savePreferences() {
    if (this.locationSelect === 'custom') {
      const location: any = {
        latitude: this.selectedGeo.lat,
        longitude: this.selectedGeo.lng,
      }
      this.$store.dispatch('setUserLocation', location);
      this.$router.replace('participate/online');
      return; 
    }

    if (this.allowedGeo) {
      this.$store.dispatch('setUserLocation', this.currentPosition);
      this.$router.replace('participate/online');
      return;
    }

    if (this.locationSelect === this.userCity) {
      this.$store.dispatch('setUserLocation', this.currentPosition);
      this.$router.replace('participate/online');
      return;
    }
    
    this.$store.dispatch('setUserLocation', {});
    this.$router.replace('participate/online');
  }

  @Watch('userCountry', {deep: true})
  protected userCountryWatch(to: any) {
    if (to) this.getGeoFromCountry();
  }

  @Watch('allowedGeo', {deep: true})
  protected allowedGeoWatch(to: any) {
    if (this.allowedGeo === false) this.locationSelect = 'anonymous';
    else this.locationSelect = this.userCity;
  }

  @Watch('locationSelect', {deep: true})
  protected locationSelectWatch(to: any) {
    if (to === 'anonymous') this.allowedGeo = false;
    if (to === 'custom' || to === this.userCity) this.allowedGeo = true;
  }
}
